export default __webpack_public_path__ + "static/media/rebate_coin_02.159f6841.png";